var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.layoutType === 'vertical')?_c('vertical',[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.layoutType === 'horizontal')?_c('Horizontal',[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }